module.exports = __webpack_public_path__ + "img/floor_pay.0acff628.png";